'use client';
import LoadingSpinner from '@c/LoadingSpinner';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

export default function WelcomeTab() {
  const router = useRouter();

  useEffect(() => {
    router.replace('/welcome');
  }, [router]);

  return <LoadingSpinner />;
}
